import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { ModalService } from '@app/core/ui/modal/modal.service';
import { Address } from '@app/core/business/address';
import { Order } from '@app/core/business/order/order';
import { ContextService } from '@app/core/service/context.service';
import { CustomerService } from '@app/core/business/customer/customer.service';
import { TranslateService } from '@ngx-translate/core';
import { NgForm } from '@angular/forms';
import { DeliveryDate } from '@app/core/business/order/delivery-date';
import { Company } from '@app/core/business/company/company';
import { WizardManagerService } from '@app/core/service/wizards/wizard-manager.service';

@Component({
  selector: 'app-create-order',
  templateUrl: './create-order.component.html',
  styleUrls: ['./create-order.component.scss'],
})
export class CreateOrderComponent implements OnInit {
  public datas: { order: Order; addresses: Address[]; };
  public dates: DeliveryDate[]; // CLA le 10/10/2019 - A/B - Utilisation d'un objet DeliveryDate désormais
  public loadingDates = false;
  currentCompany: Company;

  @ViewChild('newOrderForm', { static: true })
  newOrderForm: NgForm;

  constructor(
    private injector: Injector,
    private modalService: ModalService,
    public contextService: ContextService,
    private customerService: CustomerService,
    public translateService: TranslateService,
  ) {
    this.datas = this.injector.get('datas');
  }

  ngOnInit() {

  }

  public close(): void {
    this.modalService.destroy();
  }

  public validate(): void {
    if (this.newOrderForm.valid) {
      this.modalService.validate(this.datas.order);


    }
  }

  public fetchDates(): void {
    this.loadingDates = true;

    // CLA le 13/11/2019, changement de contexte, réinitialisation des valeurs
    this.dates = null;
    this.datas.order.deliveryDate = "";

    // Force le type de commande au Frais (plus de surgelés)
    this.datas.order.orderType = "NOR";

    // CLA le 10/10/2019 - A/B - on précise le type de commande
    this.customerService
      .getDeliveryDates(
        this.contextService.context.companyCode,
        this.contextService.context.customerCode,
        this.datas.order.deliveryAddress.code,
        this.datas.order.orderType
      )
      .subscribe(
        dates => {
          this.dates = dates;
        },
        () => {
          this.loadingDates = false;
        },
        () => {
          this.loadingDates = false;
        }
      );
  }
}
